import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpStatusCode } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { NotificationService } from '../services';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  constructor(private notification: NotificationService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error) => {
        switch (error.status) {
          case HttpStatusCode.Unauthorized:
          case HttpStatusCode.InternalServerError:
            this.notification.displayError('Please Contact Support.', 'We are experiencing issues.');
            break;

          case HttpStatusCode.Forbidden:
            this.notification.displayError('Please Contact Support.', 'Permission Denied');
            break;

          case HttpStatusCode.NotFound:
            this.notification.displayError('Please Contact Support', 'Error - Not Found');
            break;

          default:
            break;
        }

        const errorOutput = (error && error?.error?.message && error?.error?.errors) || error.error.message;
        return throwError(errorOutput);
      }),
    );
  }
}
